import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { Actions } from '../actions'
import {
  getAvatarUrl,
  getArtistName,
  getUserId,
  getIsUsersCollectionPage,
  getHasValidPermissions,
} from '../selectors/app'
import { getIsPubliclySearchableSelected } from '../selectors/algolia'
const mapStateToProps = createStructuredSelector({
  hasValidPermissions: getHasValidPermissions,
  isUsersCollectionPage: getIsUsersCollectionPage,
  avatarUrl: getAvatarUrl,
  artistName: getArtistName,
  artistId: getUserId,
  isPublic: getIsPubliclySearchableSelected,
})

const mapDispatchToProps = (dispatch) => ({
  toggleViewType: () => dispatch(Actions.TOGGLE_VIEW_TYPE()),
})

export type ConnectorProps = {
  avatarUrl: string
  artistName: string
  artistId: number
  hasValidPermissions: boolean
  isUsersCollectionPage: boolean
  isPublic: boolean
  toggleViewType: (...args: Array<any>) => any
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect